<template>
  <v-app-bar max-height="48px" flat color="grey darken-3" fixed dense dark>
    <slot name="sidebar"></slot>

    <v-toolbar-title>
      <v-img src="static/logo-header.png" class="cursor-pointer" max-width="90" max-height="auto" @click="handleLoadTemplate"></v-img>
    </v-toolbar-title>

    <v-spacer />

    <devEnvironments :environments="environments" />

    <v-btn text small target="_blank" href="http://sitedev/portaldev/docs/"> <v-icon small class="mr-1">library_books</v-icon>Documentação </v-btn>

    <v-btn text small v-if="profile">
      <v-icon small class="mr-1" dark>account_circle</v-icon>
      {{ profile.name }}
    </v-btn>

    <v-btn text small v-if="profile" @click="logoff()" :loading="loading"> <v-icon small class="mr-1" dark>power_settings_new</v-icon>Sair </v-btn>
  </v-app-bar>
</template>

<script>
import { getEnvironments } from '@/services/dev';

export default {
  components: {
    devEnvironments: () => import('@/components/dev/dev-environments')
  },

  data: () => ({
    environments: [],
    loading: false
  }),

  async mounted() {
    const { data } = await getEnvironments();

    this.environments = data;
  },

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    initialSchema() {
      return this.$store.getters['dev/getInitialSchema'];
    },

    typeOfPageEditing() {
      return this.$store.getters['dev/getTypeOfPageEditing'];
    },

    profile() {
      return this.$store.getters['authentication/getUser'] || JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;
    }
  },

  methods: {
    handleLoadTemplate() {
      if (this.typeOfPageEditing !== '' && JSON.stringify(this.schema) !== JSON.stringify(this.initialSchema)) {
        this.$store.dispatch('dev/setConfirmPageChanges', { dialog: true, origin: 'header', fileName: '' });

        return;
      }

      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setCurrentTemplate', 'templateHome');
    },

    logoff() {
      this.loading = true;
      this.$store.dispatch('authentication/logoff');
    }
  }
};
</script>
